import * as React from 'react'
import { useCallback } from 'react'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { ClosedWonQueueLink } from '../ClosedWonQueueLink/ClosedWonQueueLink'
import { SoldServiceReviseNote } from '../SoldServiceReviseNote/SoldServiceReviseNote'
import { SoldServicesBanner } from '../SoldServicesBanner'
import { SoldServicesCompletionDetailsCardList } from '../SoldServicesCompletionDetailsCardList'
import { getStyles } from './styling'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {
  openDialogActionCreator as openDialog,
  useCWQDialogContext,
} from '../CWQDialogContext'
import { useTheme } from '@mui/material/styles'

interface Props {
  opportunityId: number
  onReOpenClick: () => void
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export function SoldServicesDetails(props: Props) {
  const { soldServiceStatus, opportunityId } = props

  const [, dispatch] = useCWQDialogContext()

  const onViewSubmissionClick = useCallback(
    () => dispatch(openDialog('ssq')),
    [dispatch],
  )
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.root}>
      <SoldServicesBanner {...props} />
      {soldServiceStatus === 'Completed' && (
        <SoldServicesCompletionDetailsCardList {...props} />
      )}
      {soldServiceStatus === 'Revise' && <SoldServiceReviseNote {...props} />}
      <Box sx={styles.linkBox} display="flex" justifyContent="left">
        <Button
          sx={styles.link}
          onClick={onViewSubmissionClick}
          data-test-id={`opportunity-view-submission-button-${opportunityId}`}
        >
          View Submission
        </Button>
        <ClosedWonQueueLink />
      </Box>
    </Box>
  )
}
